import * as Sentry from '@sentry/react-native';

import { buildCaptureMessageContext, type CaptureMessageLevel } from './captureMessageContext';
import type { Logger, User } from './types';

const sentryLogger: Logger = {
  addBreadcrumb: (message: string, data?: Record<string, unknown>) => {
    Sentry.addBreadcrumb({
      message,
      data,
      level: 'info',
    });
  },

  captureException: (error: unknown, context?: Record<string, unknown>) => {
    Sentry.captureException(error, {
      extra: context,
    });
  },

  captureMessage: (
    message: string,
    level: CaptureMessageLevel = 'info',
    context?: Record<string, unknown>,
  ) => {
    Sentry.captureMessage(message, buildCaptureMessageContext(message, level, context));
  },

  setUser: (user: User | null) => {
    Sentry.setUser(user ? { id: user.id } : null);
  },
};

export { sentryLogger };
